import { updateKeyInStore } from 'App';
import {
  TaxesPaidStateValues,
  TEstimatesTaxPaymentsTableRow,
  updateKey,
} from '../slice';

export const uploadFields: IBaseField<
  keyof TaxesPaidStateValues | keyof TEstimatesTaxPaymentsTableRow
>[] = [
  {
    name: 'pleaseUploadCorrespondingTaxFormw210991042SEtc',
    label: 'Please upload corresponding tax form (W2, 1099, 1042-S, etc)',
    subLabel: () => <p>All US Tax Withheld has a corresponding tax form</p>,
    type: 'upload',
    predicate: (value) => value === 'yes',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    dependentOn:
      'taxQuestionnaire.taxesDeductions.taxesPaid.values.didYouPayAnyUsTaxIsYear',
  },
];
